import { assign, createMachine } from "xstate";
import {
  fetchCountries,
  fetchZones,
  IRoamingInternationalCountry,
  IZone,
} from "@nju/data-access-portal-dashboard";

type IEvent =
  | { type: "ERROR" }
  | {
      type: "SUCCESS";
      countries: IRoamingInternationalCountry[];
      zones: IZone[];
    };

interface IContext {
  countries: IRoamingInternationalCountry[] | undefined;
  zones: IZone[] | undefined;
}

export const areaInternationalPageMachine = createMachine(
  {
    schema: {
      events: {} as IEvent,
      context: {} as IContext,
    },
    initial: "loading",
    states: {
      loading: {
        invoke: {
          src: "fetchRequiredData",
        },
        on: {
          SUCCESS: {
            actions: "setRequiredData",
            target: "finish",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      finish: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setRequiredData: assign((context, event: IEvent) => {
        if (event.type === "SUCCESS") {
          return {
            countries: event.countries,
            zones: event.zones,
          };
        }

        return context;
      }),
    },
    services: {
      fetchRequiredData: () => {
        return async (callback) => {
          try {
            const [countries, zones] = await Promise.all([
              fetchCountries({ brand: "NJU", category: "INTERNATIONAL" }),
              fetchZones(),
            ]);

            callback({
              type: "SUCCESS",
              countries: countries.unwrap(),
              zones: zones.unwrap(),
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
